import React from "react";
import DocumentViewer from "../../components/documents/document-viewer";

const BugAttachmentViewerPage: React.FC = () => {
  return (
    <DocumentViewer
      downloadEndpointBuilder={(id) => `/api/app-management/bug-logs/attachments/${id}/download`}
      backPath="/app-management/bug-reports"
      title="Bug Attachment Viewer"
    />
  );
};

export default BugAttachmentViewerPage;
